import Geocode from 'react-geocode';
Geocode.setApiKey('AIzaSyCWb6_X0cafRdSY9Qo4q_rR7HPFE3-9x_U');

export const reverseGeocodeCoordinates = async ({ latitude, longitude }) => {
    let response = await Geocode.fromLatLng(latitude, longitude);
    const address = response.results[0].formatted_address;
    return address;
};
